import {useContext} from "react";
import { useNavigate } from 'react-router-dom';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faBell,
  faGear,
  faQuestion,
  faUser,
  faUserGear
} from "@fortawesome/free-solid-svg-icons";
import {gameLibraryIcon} from "../Assets/GameLibraryIcon"
import AuthContext from "../../store/auth-context";

const MainNavigation = () => {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  const menuLinks = [
    { path: '/games/', label: 'Game Library', icon: gameLibraryIcon, requireAuth: true, requireAdmin: false }, //faTrainSubway
    { path: '/sessions/', label: 'Sessions', icon: faUser, requireAuth: true, requireAdmin: false },
    { path: '/help/', label: 'Help', icon: faQuestion, requireAuth: false, requireAdmin: false },
    { path: '/notifications/', label: 'Notification', icon: faBell, requireAuth: true, requireAdmin: false },
    { path: '/user_settings/', label: 'Settings', icon: faGear, requireAuth: true, requireAdmin: false },
    { path: '/admin/', label: 'Admin', icon: faUserGear, requireAuth: true, requireAdmin: true },
    { path: '/logout/', label: 'Logout', icon: faArrowRightFromBracket, requireAuth: false, requireAdmin: false }
  ];

  const renderMenuLink = (menuItem, idx) => {
    const pathname = window.location.pathname
    const {path, label, icon, requireAuth, requireAdmin} = menuItem;
    const isActive = pathname === path;

    if (requireAuth && !authCtx.isLoggedIn)
      return undefined;
    if (requireAdmin && authCtx.userRole !== 'admin')
      return undefined;
    return (
      <button className={isActive ? "main-navigation-button-style main-navigation-button-style-active" : "main-navigation-button-style"}
              key={idx}
              onClick={() => { navigate(path) }}>
        <FontAwesomeIcon icon={icon} className={"fa-2x"} />
        <div className={"main-navigation-buttonText"}>
          {label}
        </div>
      </button>
    );
  }

  // -------------------------------------

  return (

      // <div style={{textAlign: "end"}}>
        menuLinks.map((menuLink, idx) => renderMenuLink(menuLink, idx))
      // </div>
  );
};

export default MainNavigation;
